import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userTaxInfoBackend } from './user-tax-info.backend';
import { userTaxInfoReducer } from './user-tax-info.reducer';

@NgModule({
  imports: [
    BackendModule.forFeature('userTaxInfo', userTaxInfoBackend),
    StoreModule.forFeature('userTaxInfo', userTaxInfoReducer),
  ],
})
export class DatastoreUserTaxInfoModule {}
